import { REMOVER_FILTRO_MANUTENCAO_VEICULO } from '../types'

export default function removerFiltroManutencaoVeiculo (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_MANUTENCAO_VEICULO
  }
}
